import React, { useState, useEffect } from 'react';
import { API_CONFIG } from '../../config/api';
import './NetworkStats.css';

const NetworkStats = ({ rpcUrl = API_CONFIG.RPC_URL, chainData = {}, consensusMetrics = {} }) => {
  const [networkData, setNetworkData] = useState({
    rpcStatus: 'unknown',
    blockHeight: 0,
    chainId: 1337,
    syncStatus: 'synced',
    totalNodes: 0
  });

  useEffect(() => {
    // Update network data based on real blockchain data only
    const updateNetworkData = async () => {
      try {
        // Get real network stats - use rpcUrl parameter
        const response = await fetch(rpcUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            jsonrpc: '2.0',
            method: 'avo_getNetworkStats',
            params: [],
            id: 1
          })
        });
        
        const result = await response.json();
        if (result.result) {
          const stats = result.result;
          
          setNetworkData(prev => ({
            ...prev,
            blockHeight: chainData.height || 0,
            chainId: stats.chain_id || 1337,
            rpcStatus: 'connected',
            totalNodes: stats.active_validators || 0,
            syncStatus: 'synced'
          }));
        }
      } catch (error) {
        console.error('Failed to fetch real network data:', error);
        // Fallback to basic data from props
        setNetworkData(prev => ({
          ...prev,
          blockHeight: chainData.height || 0,
          chainId: chainData.chainId || 1337,
          rpcStatus: chainData.height > 0 ? 'connected' : 'disconnected',
          totalNodes: consensusMetrics.total_nodes || 0,
          syncStatus: 'synced'
        }));
      }
    };

    updateNetworkData();
  }, [chainData, consensusMetrics]);

  const getStatusClass = (status) => {
    switch(status) {
      case 'connected': return 'status-ok';
      case 'disconnected': return 'status-error';
      case 'syncing': return 'status-warning';
      default: return 'status-warning';
    }
  };

  return (
    <div className="network-stats-minimal">
      <div className="network-header-minimal">
        <h3 className="section-title-minimal">Network Statistics</h3>
        <div className="network-status-minimal">
          <span className={`status-indicator-minimal ${getStatusClass(networkData.rpcStatus)}`}>
            {networkData.rpcStatus.toUpperCase()}
          </span>
        </div>
      </div>

      <div className="network-grid-minimal">
        <div className="metric-card-network">
          <div className="metric-content-network">
            <div className="metric-label-network">Block Height</div>
            <div className="metric-value-network">{networkData.blockHeight}</div>
            <div className="metric-sublabel-network">Current</div>
          </div>
        </div>

        <div className="metric-card-network">
          <div className="metric-content-network">
            <div className="metric-label-network">Chain ID</div>
            <div className="metric-value-network">{networkData.chainId}</div>
            <div className="metric-sublabel-network">AVO Protocol</div>
          </div>
        </div>

        <div className="metric-card-network">
          <div className="metric-content-network">
            <div className="metric-label-network">Total Nodes</div>
            <div className="metric-value-network">{networkData.totalNodes}</div>
            <div className="metric-sublabel-network">Network</div>
          </div>
        </div>

        <div className="metric-card-network">
          <div className="metric-content-network">
            <div className="metric-label-network">Sync Status</div>
            <div className={`metric-value-network ${getStatusClass(networkData.syncStatus)}`}>
              {networkData.syncStatus.toUpperCase()}
            </div>
            <div className="metric-sublabel-network">Blockchain</div>
          </div>
        </div>
      </div>

      <div className="network-details-minimal">
        <div className="detail-section">
          <h4 className="detail-title-minimal">Network Health</h4>
          <div className="detail-grid">
            <div className="detail-item">
              <span className="detail-label">RPC Endpoint:</span>
              <span className="detail-value">{rpcUrl}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Network Status:</span>
              <span className={`detail-value ${getStatusClass(networkData.rpcStatus)}`}>
                {networkData.rpcStatus === 'connected' ? 'Healthy' : 
                 networkData.rpcStatus === 'syncing' ? 'Syncing' : 'Disconnected'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NetworkStats;